import { render, staticRenderFns } from "./ToggleBox.vue?vue&type=template&id=f8cc0c2c"
import script from "./ToggleBox.vue?vue&type=script&lang=js"
export * from "./ToggleBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports